import {Injectable} from "@angular/core";
import {environment} from "environments/environment";
import mixpanel from "mixpanel-browser";

@Injectable({
    providedIn: "root",
})
export class MixpanelService {
    private mToken: string = environment.MIXPANEL_TOKEN;
    constructor() {
        this.init();
    }

    init(): void {
        mixpanel.init(this.mToken, {
            debug: false,
        });
    }

    identify(alias: string) {
        mixpanel.identify(alias);
    }

    track(id: string, action: any = {}): void {
        mixpanel.track(id, action);
    }

    setup() {
        this.setSuperProperties({Platform: "WINNER_DP PORTAL"});
    }

    setSuperProperties(properties) {
        mixpanel.register(properties);
    }

    setPeople(properties: any = {}): void {
        mixpanel.people.set(properties);
    }

    sendEvent(event: string, properties?) {
        if (properties) {
            mixpanel.track(event, properties);
        } else {
            this.trackEvent(event);
        }
    }

    trackEvent(event: string) {
        mixpanel.track(event);
    }

    trackAppOpened() {
        this.sendEvent("App Opened", {
            timestamp: new Date().toISOString(),
        });
    }

    logout() {
        mixpanel.reset();
    }
}
